<app-search-bar *transloco="let t" (onSearch)="onSearchQueryInput($event)" (onSelectItem)="openEventDetails($event)"
                [searchPlaceholder]="t('explore.search')" [isLoading]="isLoading" [inputValue]="inputValue"
                [showEmptyState]="showEmptyState" [items]="events"
                [isTransparent]="isTransparent"/>
